import { formatCPFAndCNPJ } from '@/app/utils/numberUtils';
import { useEffect, useState } from 'react';

export default function useFormattedCpfAndCpnj(initialValue: number | string | null | undefined) {
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (initialValue != null) {
      setValue(formatCPFAndCNPJ(initialValue));
    }
  }, [initialValue]);

  return { value, setValue };
}
